import Vuex from "vuex";
import Vue from "vue";
import axios from "axios";
import * as easings from "vuetify/es5/services/goto/easing-patterns";

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    easings: Object.keys(easings),
    selectedDiv: "",
    synFludUnR: "",
    distributed: false,
    railway: false,
    flyway: false,
    showStrCB: false,
    ppath: [],
    flN: "",
    flD: "",
    computedDateFormatted: "",
    position: 0,
    manArrAir: "",
    manDepAir: "",
    manArrAirAN: "",
    manDepAirAN: "",
    manArrAirZB: "",
    manDepAirZB: "",
    pass20: false,
    pass21: false,
    pass24: false,
    pass31: false,
    pass33: false,
    pass34: false,
    pass35: false,
    pass36: false,
    pass37: false,
    pass40: false,
    pass50: false,
    pass51: false,
    pass60: false,
    pass70: false,
    pass80: false,
    manRunSs: false,
    dataTrain: {},
    dataEP: {},
    dataFS: {},
    dataFSAN: {},
    dataFSZB: {},
    airports: {},
    airlines: {},
    preSelectedUData: {},
    progress: false,
    selectedCase: "",
    selectMi: "",
    selectDi: "",
    selectIn: "",
    selectAl: "",
    rd4Upload: false,
    rejectionMessage:
      'Es tut uns leid. Unter den geschilderten Gegebenheiten steht Ihnen vermutlich kein Entschädigungsanspruch zu. Natürlich ist aber nicht auszuschließen, dass atypische Eigenheiten Ihres Falls einen Entschädigungsanspruch ausnahmsweise rechtfertigen. Falls Ihres Erachtens besondere, bislang nicht abgefragte Begleitumstände eine andere Bewertung Ihrer Flugunregelmäßigkeit nahelegen, kontaktieren Sie gerne unseren Kundenservice. Weitere Informationen zu den Voraussetzungen einer Flugentschädigung erhalten Sie <a href="https://www.ersatz-pilot.de/fluggastentschaedigung-ausgeschlossen/">hier</a>.',
    bsfiles: [],
    nsfiles: [],
    ksfiles: [],
    vsfiles: [],
    selectedInfoCrew: "",
    selectedInfoAirline: "",
    selectedInfoOther: "",
    selectedAlternativflug: "",
    selectedCheckIn451: "",
    selectedCheckIn452: "",
    itemsJN: [],
    cases: [],
    firstFlightDelay: "",
    wAdditional: false,
    arrDateF1F: "",
    depDateF1F: "",
    timeAF1F: "",
    timeDF1F: "",
    noChange: false,
    flDAN: "",
    flDZB: "",
    flOODE: false,
    shRE: false,
    trfdbPreAB: false,
    provedata: {},
    anschFLS: false,
    zubiFLS: false,
    offertext: "",
    dateFormatted: "",
    uploadMeldung: "",
    user: null,
    labelSL: "",
    labelDR: "",
    maxGeb: "",
    zbMinDate: "",
    zbMaxDate: "",
    anMinDate: "",
    anMaxDate: "",
    actMaxDate: "",
    maxflDTRF: "",
    textReason: "",
    kiofCla: "",
    sCase: "",
    lang: [],
    finalFormData: new FormData(),
    selectedLang: [],
    contractLang: "",
    showWarning: true,
    af915: false,
    newAGB: false,
    trfTraveler: 1,
    airportMap: new Map(),
    airlineMap: new Map(),
    bCRules: [],
    tNRules: [],
    flDRules: [
      (v) => !!v || "Bitte geben Sie eine gültiges Datum ein.",
      (v) =>
        /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/.test(
          v
        ) || "Bitte geben Sie eine gültige Flugnummer ein",
    ],
    emailRules: [
      (v) => !!v || "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      (v) =>
        /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/.test(
          v
        ) || "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    ],
  };
};

export default new Vuex.Store({
  state: getDefaultState(),

  getters: {
    getSelectedDiv: (state) => {
      return state.selectedDiv;
    },
    peek: (state) => {
      return state.ppath[state.ppath.length - 1];
    },
    options: () => {
      return {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      };
    },
  },

  mutations: {
    setSelectedDiv(state, id) {
      state.selectedDiv = id;
      if (id == "32") {
        state.noChange = true;
      }
    },
    pop(state) {
      state.ppath.pop();
    },
    changeStatePass(state, payload) {
      state["pass" + payload.id] = payload.val;
    },
    setFSDataVar(state, payload) {
      state.dataFS[payload.pos] = payload.val;
    },
    async setVar(state, payload) {
      state[payload.pos] = payload.val;
    },
    setFlightData(state, payload) {
      state[payload.target] = payload.data;
    },
    addStepOnPath(state, val) {
      state.ppath.push(val);
    },
    setPosition(state, val) {
      state.position = val;
    },
    clearState(state) {
      Object.assign(state, getDefaultState());
    },
    clearArray(state, val) {
      state[val] = {};
    },
    add2Array(state, payload) {
      state[payload.target].push(payload.val);
    },
    add2Map(state, payload) {
      state[payload.target].set(payload.id, payload.val);
    },
  },

  actions: {
    clearArrays(context, id) {
      context.commit("clearArray", id);
    },
    setSelectedDiv(context, id) {
      context.commit("setSelectedDiv", id);
    },
    add2Array(context, payload) {
      context.commit("add2Array", payload);
    },
    async killRun(context, payload) {
      var lang = context.state.lang;
      var selectedLang = context.state.selectedLang;
      var itemsJN = context.state.itemsJN;
      var cL = context.state.contractLang;
      var airports = context.state.airports;
      var airlines = context.state.airlines;
      var airportMap = context.state.airportMap;
      var airlineMap = context.state.airlineMap;
      var distributed = context.state.distributed;
      var railway = context.state.railway;
      var flyway = context.state.flyway;
      await payload.vm.$nextTick();
      var elmnt = document.getElementById("pass1FID");
      if (context.state.kiofCla == "TRFDB") {
        elmnt = document.getElementById("pass1RID");
      }
      elmnt.scrollIntoView();
      context.commit("clearState");
      context.commit("setVar", { pos: "lang", val: lang });
      context.commit("setVar", {
        pos: "selectedLang",
        val: selectedLang,
      });
      var cases = [
        {
          text: selectedLang.AdditionalFlightsTile18,
          val: "L",
          valN: 1,
        },
        {
          text: selectedLang.AdditionalFlightsTile76,
          val: "C",
          valN: 2,
        },
        {
          text: selectedLang.AdditionalFlightsTile77a,
          val: "TRF",
          valN: 3,
        },
        {
          text: selectedLang.AdditionalFlightsTile77b,
          val: "TRF",
          valN: 4,
        },
        {
          text: selectedLang.AdditionalFlightsTile77c,
          val: "TRF",
          valN: 5,
        },
        {
          text: selectedLang.AdditionalFlightsTile77,
          val: "NB",
          valN: 6,
        },
      ];
      context.commit("setVar", { pos: "itemsJN", val: itemsJN });
      context.commit("setVar", { pos: "cases", val: cases });
      context.commit("setVar", { pos: "contractLang", val: cL });
      context.commit("setVar", { pos: "airports", val: airports });
      context.commit("setVar", { pos: "airlines", val: airlines });
      context.commit("setVar", { pos: "airportMap", val: airportMap });
      context.commit("setVar", { pos: "airlineMap", val: airlineMap });
      context.commit("setVar", { pos: "distributed", val: distributed });
      context.commit("setVar", { pos: "railway", val: railway });
      context.commit("setVar", { pos: "flyway", val: flyway });
    },
    backToSpecificTile(context, pos) {
      while (context.getters.peek != pos) {
        let xy = context.getters.peek;
        context.commit("pop");
        context.commit("changeStatePass", { id: xy, val: false });
      }
      context.commit("setSelectedDiv", context.getters.peek);
      context.commit("changeStatePass", {
        id: context.getters.getSelectedDiv,
        val: false,
      });
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    setFSDataVar(context, payload) {
      context.commit("setFSDataVar", payload);
    },
    setVar(context, payload) {
      context.commit("setVar", payload);
    },
    setLang(context, payload) {
      let lang = payload.bsl.substring(0, 2);
      if (lang == "de") {
        context.commit("setVar", {
          pos: payload.pos,
          val: context.state.lang.de,
        });
      } else {
        context.commit("setVar", {
          pos: payload.pos,
          val: context.state.lang.en,
        });
      }
    },
    async goToStep(context, payload) {
      context.commit("addStepOnPath", payload.val);
      await payload.vm.$nextTick();
      var elmnt = document.getElementById("pass" + payload.val);
      elmnt.scrollIntoView();
    },
    async getFlightData(context, payload) {
      const data = await axios
        .post(
          "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/getFlight.php",
          {
            flD: payload.flD,
            flN: payload.flN,
            target: payload.target,
          }
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
      context.commit("setFlightData", { target: payload.target, data: data });
    },
    async getRailData(context, payload) {
      const data = await axios
        .post(
          "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/getRailJourney.php",
          {
            bookingCode: payload.bookingCode,
            travelerName: payload.travelerName,
          }
        )
        .then((response) => {
          if (response.status == 200) {
            if (response.data.statusCode == 200) {
              let liof = response.data.travelerName.lastIndexOf(" ");
              let preCheckUser = {};
              preCheckUser.firstName = response.data.travelerName.substring(
                0,
                liof
              );
              preCheckUser.lastName = response.data.travelerName.substring(
                liof + 1
              );
              if (response.data.bookerName != response.data.travelerName) {
                liof = response.data.bookerName.lastIndexOf(" ");
                preCheckUser.abfn = response.data.bookerName.substring(0, liof);
                preCheckUser.abln = response.data.bookerName.substring(
                  liof + 1
                );
              }
              context.commit("setVar", {
                pos: "preSelectedUData",
                val: preCheckUser,
              });
              return response.data;
            } else if (response.data.statusCode == 333) {
              context.commit("setVar", {
                pos: "rejectionMessage",
                val: context.state.selectedLang.FirstTrainTile21,
              });
              return {};
            } else if (response.data.statusCode == 334) {
              context.commit("setVar", {
                pos: "rejectionMessage",
                val: context.state.selectedLang.FirstTrainTile22,
              });
              return {};
            } else {
              context.commit("setVar", {
                pos: "rejectionMessage",
                val: context.state.selectedLang.AdditionalTrainTile16,
              });
              return {};
            }
          } else {
            context.commit("setVar", {
              pos: "rejectionMessage",
              val: context.state.selectedLang.AdditionalTrainTile16,
            });
            return {};
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
          return {};
        })
        .finally();
      context.commit("setVar", { pos: "dataTrain", val: data });
    },
    async getAirports(context) {
      if (context.state.airports.length > 0) return;
      this.isLoading = true;
      fetch(
        "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/getAirportsNew.php"
      )
        .then((res) => res.json())
        .then((res) => {
          context.commit("setVar", { pos: "airports", val: res });
          res.forEach((element) => {
            context.commit("add2Map", {
              target: "airportMap",
              id: element.airportIATA,
              val: element,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    async getAirlines(context) {
      if (context.state.airlines.length > 0) return;
      this.isLoading = true;
      fetch(
        "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/getAirlinesNew.php"
      )
        .then((res) => res.json())
        .then((res) => {
          context.commit("setVar", { pos: "airlines", val: res });
          res.forEach((element) => {
            context.commit("add2Map", {
              target: "airlineMap",
              id: element.airlineIATA,
              val: element,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    getText() {
      return new Promise(function (resolve, reject) {
        fetch(
          "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/getTextfields.php"
        )
          .then((res) => res.json())
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          })
          .finally();
      });
    },
    setText(context, payload) {
      var itemsJN;
      var cases;
      var bCRules;
      var tNRules;
      context.commit("setVar", { pos: "lang", val: payload.res });
      let lang = payload.value.substring(0, 2);
      if (lang == "de") {
        context.commit("setVar", {
          pos: "selectedLang",
          val: payload.res.de,
        });
        itemsJN = [
          { state: "Ja", val: "y" },
          { state: "Nein", val: "n" },
        ];
        context.commit("setVar", {
          pos: "itemsJN",
          val: itemsJN,
        });
        cases = [
          {
            text: payload.res.de.AdditionalFlightsTile18,
            val: "L",
            valN: 1,
          },
          {
            text: payload.res.de.AdditionalFlightsTile76,
            val: "C",
            valN: 2,
          },
          {
            text: payload.res.de.AdditionalFlightsTile77a,
            val: "TRF",
            valN: 3,
          },
          {
            text: payload.res.de.AdditionalFlightsTile77b,
            val: "TRF",
            valN: 4,
          },
          {
            text: payload.res.de.AdditionalFlightsTile77c,
            val: "TRF",
            valN: 5,
          },
          {
            text: payload.res.de.AdditionalFlightsTile77,
            val: "NB",
            valN: 6,
          },
        ];
        context.commit("setVar", {
          pos: "cases",
          val: cases,
        });
        bCRules = [
          (v) => !!v || payload.res.de.FirstTrainTile7 + "",
          (v) =>
            /^([a-zA-Z0-9]{6,}|\d{12}\s*)$/.test(v) ||
            payload.res.de.FirstTrainTile7 + "",
            (v) => /^\d{12}\s*$/.test(v) || payload.res.de.FirstTrainTile7 + "",
        ]
        context.commit("setVar", {
          pos: "bCRules",
          val: bCRules,
        });
        tNRules = [
          (v) => !!v || payload.res.de.FirstTrainTile11 + "",
          (v) => /^([^0-9]*)$/.test(v) || payload.res.de.FirstTrainTile12 + "",
          (v) => v.length >= 3 || payload.res.de.FirstTrainTile13 + "",
        ];
        context.commit("setVar", {
          pos: "tNRules",
          val: tNRules,
        });
        context.commit("setVar", { pos: "contractLang", val: "de" });
      } else {
        context.commit("setVar", {
          pos: "selectedLang",
          val: payload.res.en,
        });
        itemsJN = [
          { state: "Yes", val: "y" },
          { state: "No", val: "n" },
        ];
        context.commit("setVar", {
          pos: "itemsJN",
          val: itemsJN,
        });
        cases = [
          {
            text: payload.res.en.AdditionalFlightsTile18,
            val: "L",
            valN: 1,
          },
          {
            text: payload.res.en.AdditionalFlightsTile76,
            val: "C",
            valN: 2,
          },
          {
            text: payload.res.en.AdditionalFlightsTile77a,
            val: "TRF",
            valN: 3,
          },
          {
            text: payload.res.en.AdditionalFlightsTile77b,
            val: "TRF",
            valN: 4,
          },
          {
            text: payload.res.en.AdditionalFlightsTile77c,
            val: "TRF",
            valN: 5,
          },
          {
            text: payload.res.en.AdditionalFlightsTile77,
            val: "NB",
            valN: 6,
          },
        ];
        context.commit("setVar", {
          pos: "cases",
          val: cases,
        });
        bCRules = [
          (v) => !!v || payload.res.de.FirstTrainTile7 + "",
          (v) =>
            /^([a-zA-Z0-9]{6,}|\d{12}\s*)$/.test(v) ||
            payload.res.de.FirstTrainTile7 + "",
            (v) => /^\d{12}\s*$/.test(v) || payload.res.de.FirstTrainTile7 + "",
        ];
        context.commit("setVar", {
          pos: "bCRules",
          val: bCRules,
        });
        tNRules = [
          (v) => !!v || payload.res.en.FirstTrainTile11 + "",
          (v) => /^([^0-9]*)$/.test(v) || payload.res.en.FirstTrainTile12 + "",
          (v) => v.length >= 3 || payload.res.en.FirstTrainTile13 + "",
        ];
        context.commit("setVar", {
          pos: "tNRules",
          val: tNRules,
        });
        context.commit("setVar", { pos: "contractLang", val: "en" });
      }
    },
  },
});
